import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { addCompanyApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const addCompany = createAsyncThunk('addCompany', async (payload) => {
  return await addCompanyApi(payload);
});

const addCompanySlice = createSlice({
  name: 'addCompany', // Unique Name
  initialState,
  reducers: {
    addCompanyReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addCompany.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(addCompany.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(addCompany.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { addCompanyReset } = addCompanySlice.actions;

export default addCompanySlice.reducer;
